import { render, staticRenderFns } from "./ModulePvsyst.vue?vue&type=template&id=12dcdac2&scoped=true"
import script from "./ModulePvsyst.vue?vue&type=script&lang=js"
export * from "./ModulePvsyst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dcdac2",
  null
  
)

export default component.exports